/**
 * Get the current timezone
 * @returns {string|number} Offset in seconds or TimeZone ID if available
 */
export function getTimezone() {
  if (window.Intl && window.Intl.DateTimeFormat) {
    return Intl.DateTimeFormat().resolvedOptions().timeZone
  }
  return -1 * (new Date().getTimezoneOffset() / 60)
}